import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import './AiToolsWorkbench.scss';

const AiToolsWorkbench = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const aiTools = [
    {
      id: 'video-generation',
      title: t('catoo.videoGeneration'),
      description: t('catoo.videoGenerationDesc'),
      icon: '🎬',
      gradient: 'linear-gradient(135deg, #00A86B 0%, #00e5b8 100%)',
      route: '/ai-tools/veo-video-generator',
      features: ['Text-to-Video', 'Image-to-Video']
    },
    {
      id: 'mv-generation',
      title: t('videoGeneration.mv.meta.title'),
      description: t('videoGeneration.mv.meta.desc'),
      icon: '🎵',
      gradient: 'linear-gradient(135deg, #00A86B 0%, #22d3ee 100%)',
      route: '/ai-tools/mv-generator',
      features: t('videoGeneration.mv.hero.tags')
    },
    {
      id: 'photo-restoration',
      title: t('aiWorkbench.tools.photoRestoration.title'),
      description: t('aiWorkbench.tools.photoRestoration.description'),
      icon: '🔧',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      route: '/ai-tools/photo-restoration',
      features: t('aiWorkbench.tools.photoRestoration.features')
    },
    {
      id: 'wedding-photo',
      title: t('aiWorkbench.tools.weddingPhoto.title'),
      description: t('aiWorkbench.tools.weddingPhoto.description'),
      icon: '💍',
      gradient: 'linear-gradient(135deg, #ff99cc 0%, #ffd1e8 100%)',
      route: '/ai-tools/wedding-photo',
      features: t('aiWorkbench.tools.weddingPhoto.features')
    },
    {
      id: 'group-photo',
      title: t('aiWorkbench.tools.groupPhoto.title'),
      description: t('aiWorkbench.tools.groupPhoto.description'),
      icon: '👥',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      route: '/ai-tools/group-photo',
      features: t('aiWorkbench.tools.groupPhoto.features')
    },
    {
      id: 'world-view',
      title: t('aiWorkbench.tools.worldView.title'),
      description: t('aiWorkbench.tools.worldView.description'),
      icon: '🌍',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      route: '/ai-tools/world-view',
      features: t('aiWorkbench.tools.worldView.features')
    },
    {
      id: 'professional-portrait',
      title: t('aiWorkbench.tools.professionalPortrait.title'),
      description: t('aiWorkbench.tools.professionalPortrait.description'),
      icon: '👔',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      route: '/ai-tools/professional-portrait',
      features: t('aiWorkbench.tools.professionalPortrait.features')
    },
    {
      id: 'id-photo-generation',
      title: t('aiToolTemplate.tools.idPhotoGeneration.name'),
      description: t('aiToolTemplate.tools.idPhotoGeneration.description'),
      icon: '📷',
      gradient: 'linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)',
      route: '/ai-tools/id-photo-generation',
      features: [t('idPhotoGeneration.sizes.oneInch.name'), t('idPhotoGeneration.sizes.twoInch.name'), t('idPhotoGeneration.backgroundColors.title')]
    },
    {
      id: 'image-matting',
      title: t('aiWorkbench.tools.imageMatting.title'),
      description: t('aiWorkbench.tools.imageMatting.description'),
      icon: '✂️',
      gradient: 'linear-gradient(135deg, #FF9A9E 0%, #FECFEF 100%)',
      route: '/ai-tools/image-matting',
      features: t('aiWorkbench.tools.imageMatting.features')
    },
    {
      id: 'image-upscaler',
      title: t('aiWorkbench.tools.imageUpscaler.title'),
      description: t('aiWorkbench.tools.imageUpscaler.description'),
      icon: '🔍',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      route: '/image-upscaler',
      features: t('aiWorkbench.tools.imageUpscaler.features')
    },
    {
      id: 'face-swap',
      title: t('aiWorkbench.tools.faceSwap.title'),
      description: t('aiWorkbench.tools.faceSwap.description'),
      icon: '🧑‍🎨',
      gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
      route: '/ai-tools/face-swap',
      features: t('aiWorkbench.tools.faceSwap.features')
    },
    {
      id: 'logo-generation',
      title: t('logoGeneration.toolName'),
      description: t('logoGeneration.toolDescription'),
      icon: '🏷️',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      route: '/ai-tools/logo-generation',
      features: [t('logoGeneration.parameters.modern'), t('logoGeneration.parameters.creative'), t('logoGeneration.parameters.minimal')]
    },
    {
      id: 'pop-art-portrait',
      title: t('aiWorkbench.tools.popArtPortrait.title'),
      description: t('aiWorkbench.tools.popArtPortrait.description'),
      icon: '🎨',
      gradient: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
      route: '/ai-tools/pop-art-portrait',
      features: t('aiWorkbench.tools.popArtPortrait.features')
    },
    {
      id: 'anime-style',
      title: t('aiWorkbench.tools.animeStyle.title'),
      description: t('aiWorkbench.tools.animeStyle.description'),
      icon: '🌸',
      gradient: 'linear-gradient(135deg, #00e5b8 0%, #00c4a0 100%)',
      route: '/ai-tools/anime-style',
      features: t('aiWorkbench.tools.animeStyle.features')
    },
    {
      id: 'oil-painting',
      title: t('aiWorkbench.tools.oilPainting.title'),
      description: t('aiWorkbench.tools.oilPainting.description'),
      icon: '🖼️',
      gradient: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)',
      route: '/ai-tools/oil-painting',
      features: t('aiWorkbench.tools.oilPainting.features')
    },
    {
      id: 'watercolor',
      title: t('aiWorkbench.tools.watercolor.title'),
      description: t('aiWorkbench.tools.watercolor.description'),
      icon: '🎭',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      route: '/ai-tools/watercolor',
      features: t('aiWorkbench.tools.watercolor.features')
    },
    {
      id: 'sketch-style',
      title: t('aiWorkbench.tools.sketchStyle.title'),
      description: t('aiWorkbench.tools.sketchStyle.description'),
      icon: '✏️',
      gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      route: '/ai-tools/sketch-style',
      features: t('aiWorkbench.tools.sketchStyle.features')
    },
    {
      id: 'cyberpunk',
      title: t('aiWorkbench.tools.cyberpunk.title'),
      description: t('aiWorkbench.tools.cyberpunk.description'),
      icon: '🤖',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      route: '/ai-tools/cyberpunk',
      features: t('aiWorkbench.tools.cyberpunk.features')
    }
  ];

  const handleToolClick = (tool) => {
    navigate(tool.route);
  };

  return (
    <div className="ai-tools-workbench">
      <div className="workbench-header">
        <div className="header-content">
          <h1 className="workbench-title">
            <span className="title-icon">🎨</span>
            {t('aiWorkbench.workbenchTitle')}
          </h1>
          <p className="workbench-subtitle">
            {t('aiWorkbench.workbenchSubtitle')}
          </p>
        </div>
        <div className="header-decoration">
          <div className="floating-icon">✨</div>
          <div className="floating-icon">🎭</div>
          <div className="floating-icon">🖼️</div>
        </div>
      </div>

      <div className="tools-grid">
        {aiTools.map((tool) => (
          <div
            key={tool.id}
            className="tool-card"
            onClick={() => handleToolClick(tool)}
            style={{ '--card-gradient': tool.gradient }}
          >
            <div className="card-header">
              <div className="tool-icon">{tool.icon}</div>
              <div className="card-gradient-bg"></div>
            </div>
            
            <div className="card-content">
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              
              <div className="tool-features">
                {tool.features.map((feature, index) => (
                  <span key={index} className="feature-tag">
                    {feature}
                  </span>
                ))}
              </div>
            </div>
            
            <div className="card-footer">
              <button className="try-button">
                <span>{t('aiWorkbench.tryNow')}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="workbench-footer">
          <div className="footer-content">
            <h3>{t('aiWorkbench.moreComing')}</h3>
            <p>{t('aiWorkbench.moreComingDescription')}</p>
          </div>
        </div>
    </div>
  );
};

export default AiToolsWorkbench;
